import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'recipients-group',
	props: {
		label: {
			type: String,
			default: 'Grupo de destinatários'
		},
		required: {
			type: Boolean,
			default: false
		},
		selected: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		recipientGroup: ''
	}),
	computed: {
		...mapGetters([
			'ENUM'
		])
	},
	methods: {
		...mapActions([
			'setSelectedRecipientGroup',
			'setSelectedClassGrade',
			'setSelectedClassLevel'
		]),
		changed() {

			this.setSelectedClassLevel('');
			this.setSelectedClassGrade('');

			EventBus.$emit('recipientGroupSelected', this.recipientGroup);

		}
	},
	created() {

		if (this.selected) {
			this.recipientGroup = this.selected;
		}

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/recipients-group/index.js